// Each platform independently has a 2.5% chance of displaying one of four equally likely photos.
export default class PhotoSchedule {
  constructor(random = Math.random) {
    this.random = random;
  }
  next() {
    return this.random() < 0.025 ? Math.floor(this.random() * 4) : null;
  }
}
